// Packages

// Components

// Logic

// Context

// Services

// Styles
import "./Description.css";

// Assets

export const Description = () => {
	return (
		<div className='landing-hero-description'>
			Atlas Story App is a platform for writers to store and share their stories, characters, plots, world, lore, events, objects, and more,
			in any stage of development.
			<br />
			<br />
			Create stories that you love and wish to tell!
		</div>
	);
};
